import { Mail, Phone, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SITE } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="grain relative overflow-hidden bg-navy-dark text-white"
    >
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-4">
              <img
                src="/m2-logo.jpg"
                alt="M² Tuitions logo"
                className="h-14 w-14 rounded-2xl object-cover ring-1 ring-white/20"
              />
              <div>
                <p className="font-serif text-2xl font-extrabold tracking-tight">
                  M² Tuitions
                </p>
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/60">
                  {SITE.tagline}
                </p>
              </div>
            </div>
            <p className="mt-6 max-w-md font-serif text-2xl font-semibold leading-snug text-white/90 sm:text-3xl">
              Every standard. Every board.{" "}
              <span className="italic text-gold">Every corner of India.</span>
            </p>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-white/60">
              Connecting dedicated learners with top-tier educators since{" "}
              {SITE.founded} — from major metros to India's most remote
              districts.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/50">
              Talk To Us
            </p>
            <a
              href={SITE.phoneHref}
              data-testid="footer-call-link"
              className="mt-4 flex items-center gap-3 text-sm font-semibold text-white/90 transition hover:text-gold"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10">
                <Phone className="h-4 w-4" />
              </span>
              {SITE.phoneDisplay}
            </a>
            <a
              href={SITE.emailHref}
              data-testid="footer-mail-link"
              className="mt-4 flex items-center gap-3 break-all text-sm font-semibold text-white/90 transition hover:text-gold"
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/10">
                <Mail className="h-4 w-4" />
              </span>
              {SITE.email}
            </a>
            <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-white/50">
              For Teachers
            </p>
            <Link
              to="/careers"
              data-testid="footer-careers-link"
              className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-white/90 transition hover:text-gold"
            >
              Teach With M² — Apply Now
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/50">
              What We Guarantee
            </p>
            <ul className="mt-4 space-y-3 text-sm text-white/75">
              <li>2 free demo lectures — 1 hour each</li>
              <li>Easy teacher replacement</li>
              <li>Experienced & young faculty</li>
              <li>1-on-1 student counselling</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} M² Tuitions. Since {SITE.founded}.
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40">
            Personal Tuitions • Group Tuitions • Home Tuitions
          </p>
        </div>
      </div>
    </footer>
  );
}
